import React from 'react';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import image from "../images/firevisor.png";

function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

export function Header(props) {
    return (
        <React.Fragment>
            <HideOnScroll {...props}>
                <AppBar color="primary">
                    <Toolbar>
                    <img src={image} alt="Logo" style={{margin: "1%", "max-height": "50px", "max-width": "100px"}}></img>
                        <Typography variant="h6" style={{ "font-size": "200%", "text-shadow": "1px 3px black  " }}>
                            Firevisor Systems
                        </Typography>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
            <Toolbar />
        </React.Fragment>
    );
}